export default defineNuxtRouteMiddleware((to, from) => {
  if (process.server)
    return
  const { page, leave } = useAnalytics()
  leave(from.fullPath)
  page(to.fullPath)
})
